function HomePageHandler(product = '', event = '', data = {}) {
    const { metaData = {}, city = '', checkinDate = '', checkoutDate = '', totalNights = '', rating = '', nationality = '',
        countryOfResidence = '', fsc: specialCategory = '', roomInfo = [], hotelName = '' } = data,
        { } = roomInfo,
        { userId } = metaData;
    const { roomCount = 0, adultCount = 0, childCount = 0 } = getRoomInfo(roomInfo);

    let finalData = {
        Identity: userId, product: product
    }

    switch (event) {
        case 'PageView':
            break;
        case 'Login':
            break;
        case 'Search':
            finalData = { ...finalData, location: hotelName || city, checkinDate, checkoutDate, totalNights, rating, nationality, countryOfResidence, specialCategory, roomCount, adultCount, childCount , ...(hotelName? {hotelName}:{city}) }
            break;
        case 'CitySearch':
            finalData = { ...finalData, location: city }
            break;
        case 'Checkin':
            finalData = { ...finalData, checkinDate }
            break;
        case 'Checkout':
            finalData = { ...finalData, checkoutDate }
            break;
        case 'TotalNights':
            finalData = { ...finalData, totalNights }
            break;
        case 'Ratings':
            finalData = { ...finalData, rating }
            break;
        case 'Nationality':
            finalData = { ...finalData, nationality }
            break;
        case 'CountryOfResidence':
            finalData = { ...finalData, countryOfResidence }
            break;
        case 'SpecialCategory':
            finalData = { ...finalData, specialCategory }
            break;
        case 'RoomInfo':
            finalData = { ...finalData, roomCount, adultCount, childCount }
            break;
        case 'IncentiveBanner':
            break;
    }
    return finalData;
}

function getRoomInfo(roomInfo = []) {
    let roomCount = 0, adultCount = 0, childCount = 0;
    roomInfo.map(({ numberOfAdults, numberOfChild }) => {
        roomCount++;
        adultCount += parseInt(numberOfAdults);
        childCount += parseInt(numberOfChild);
    })
    return { roomCount, adultCount, childCount };
}

module.exports = { HomePageHandler }